import { useParams } from "react-router";
import { useMemo } from "react";
import { AhuName } from "@/services/backend/htz/ahu/components/ahu-name";
import t from "@/lang/lang";
import { AhuDataLabelName } from "@/services/backend/htz/ahu/components/ahu-data-label";
import { useHtzAirHandlingUnitDataShowQuery } from "@/services/backend/htz/ahu/api/ahu-data-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { H3 } from "@/shared/components/typography";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { Button } from "@/shared/components/ui/button";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "@/routes/customers/[customerId]/_components/customer-page";
import { CustomerPageBreadcrumbs } from "@/routes/customers/[customerId]/_components/customer-page-breadcrumbs";

export function CustomerHtzAhuDataRoute() {
  const { customerId, airHandlingUnitId, ahuDataId } = useParams();
  const { data, isLoading, error } = useHtzAirHandlingUnitDataShowQuery({
    id: ahuDataId!,
  });

  const breadcrumbs = useMemo(
    () => [
      {
        to: `/customers/${customerId}/htz/ahus`,
        label: t("HTZ"),
      },
      {
        to: `/customers/${customerId}/htz/ahus`,
        label: t("RLT-Anlagen"),
      },
      {
        to: `/customers/${customerId}/htz/ahus/${airHandlingUnitId}`,
        label: <AhuName airHandlingUnitId={airHandlingUnitId!} />,
      },
      {
        to: `/customers/${customerId}/htz/ahus/${airHandlingUnitId}/data/${ahuDataId}`,
        label: t("Datensätze"),
      },
      {
        to: `/customers/${customerId}/htz/ahus/${airHandlingUnitId}/data/${ahuDataId}`,
        label: <AhuDataLabelName ahuDataId={ahuDataId!} />,
      },
    ],
    [customerId, airHandlingUnitId, ahuDataId],
  );

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs breadcrumbs={breadcrumbs} />
      </CustomerPageMainHeader>
      <CustomerPageMainContent className="gap-2">
        <PersistenceContextProvider>
          <RTKQueryErrorAlert error={error} />
          {isLoading && <CardSkeleton />}
          {data && (
            <div className="flex items-center justify-between">
              <H3>
                <span>{t("Datensatz")}</span>
                <AhuDataLabelName ahuDataId={ahuDataId!} />
                <span>{t("zu RLT-Anlage")}</span>
                <AhuName airHandlingUnitId={airHandlingUnitId!} />
              </H3>
              <div className="flex gap-2">
                <PersistenceStateUsingContext />
                <Button variant="destructive" size="sm">
                  Löschen
                </Button>
              </div>
            </div>
          )}
        </PersistenceContextProvider>
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
